import React, { useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import Select from 'react-select';
import DarkSelectStyles from '../../atoms/SelectBoxStyles/SelectBoxStyles';
import { Modal } from 'react-bootstrap';
import { addEmployeeInitAction } from '../../../actions/employeesActions';
import './AddEmployeeModal.scss';

const AddEmployeeModal = ({ onCancel, onConfirm }) => {
  const uploadInputRef = useRef(null);
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [workingHrs, setWorkingHrs] = useState('');
  const [photo, setPhoto] = useState(null);
  const [renderedPhoto, setRenderedPhoto] = useState(null);
  const typeOptions = [
    { value: { is_active: 1, is_admin: 0 }, label: 'User'},
    { value: { is_active: 1, is_admin: 1 }, label: 'Admin'},
  ];
  const [type, setType] = useState(typeOptions[0]);
  const dispatch = useDispatch();
  const employeeToAdd = new FormData();

  employeeToAdd.append('avatar', photo);
  employeeToAdd.append('name', name);
  employeeToAdd.append('email', username);
  employeeToAdd.append('password', password);
  employeeToAdd.append('hours_per_week', workingHrs || '0');
  employeeToAdd.append('is_active', type.value.is_active);
  employeeToAdd.append('is_admin', type.value.is_admin);

  const handlePhotoUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      setRenderedPhoto(reader.result);
    };

    setPhoto(file);
    reader.readAsDataURL(file);
  };

  return (
    <Modal
      show
      centered
      enforceFocus={false}
      size="lg"
      onHide={onCancel}
      dialogClassName="add-employee-modal"
    >
      <Modal.Body>
        <div className="add-employee-modal-body">
          <div className='d-flex justify-content-between w-100'>
            <span>NEW EMPLOYEE</span>
            <i className='zwicon-close' onClick={onCancel} />
          </div>

          <div className='add-employee-content-container'>
            <div className='upload-container'>
              <img
                className='zwicon-upload upload-icon'
                src={`${renderedPhoto ? renderedPhoto : 'img/upload.png'}`}
                alt="Upload Img"
                onClick={() => uploadInputRef.current.click()}
              />
              <input
                ref={uploadInputRef}
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handlePhotoUpload}
              />
            </div>
            <div className='fields-container'>
                <div className='field-row d-flex flex-direction-row'>
                  <span>Name</span>
                  <input
                    className='form-control input'
                    placeholder='Input employee  name'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className='field-row d-flex flex-direction-row'>
                  <span>Username</span>
                  <input
                    className='form-control input'
                    placeholder='Input username'
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div className='field-row d-flex flex-direction-row'>
                  <span>Password</span>
                  <input
                    className='form-control input'
                    placeholder='Input password'
                    type='password'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                {
                  !type.value.is_admin && (
                    <div className='field-row d-flex flex-direction-row'>
                      <span>Working Hours (HH:mm)</span>
                      <input
                        className='form-control input'
                        placeholder='Input weekly working hours'
                        value={workingHrs}
                        onChange={(e) => setWorkingHrs(e.target.value)}
                      />
                    </div>
                  )
                }
                <div className='field-row d-flex flex-direction-row'>
                  <span>Type</span>
                  <div className='input'>
                    <Select
                      options={typeOptions}
                      value={type}
                      onChange={(seleted)=> setType(seleted)}
                      styles={DarkSelectStyles}
                    />
                  </div>
                </div>
            </div>
          </div>

          <div className="d-flex justify-content-end w-100">
            <i
              className='zwicon-checkmark'
              onClick={() => {
                dispatch(addEmployeeInitAction(employeeToAdd));
                onConfirm();
              }}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}



export default AddEmployeeModal;
